import {isFeatureEnabled} from '@github-ui/feature-flags'
import {CommentDiscussionIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'

import cardAlignmentStyles from './card-alignment.module.css'

export function CommentsEmptyState() {
  return (
    <div className={isFeatureEnabled('issue_inline_avatars') ? undefined : cardAlignmentStyles.alignWithCards}>
      <Blankslate>
        <Blankslate.Visual>
          <CommentDiscussionIcon size={24} />
        </Blankslate.Visual>
        <Blankslate.Heading as="h3">No comments yet</Blankslate.Heading>
        <Blankslate.Description>Add a comment to start the conversation.</Blankslate.Description>
      </Blankslate>
    </div>
  )
}
